/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardSchemePriceOverride } from './CardSchemePriceOverride';
import {
    CardSchemePriceOverrideFromJSON,
    CardSchemePriceOverrideFromJSONTyped,
    CardSchemePriceOverrideToJSON,
    CardSchemePriceOverrideToJSONTyped,
} from './CardSchemePriceOverride';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface PaymentFeeDto
 */
export interface PaymentFeeDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentFeeDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentFeeDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentFeeDtoCurrencyEnum}
     * @memberof PaymentFeeDto
     */
    currency: PaymentFeeDtoCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentFeeDto
     */
    fixedFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentFeeDto
     */
    variableFeePercentage: number;
    /**
     * 
     * @type {Array<CardSchemePriceOverride>}
     * @memberof PaymentFeeDto
     */
    cardSchemePriceOverrides: Array<CardSchemePriceOverride>;
    /**
     * 
     * @type {number}
     * @memberof PaymentFeeDto
     */
    locationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    activeTo?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    updated: Date;
}


/**
 * @export
 */
export const PaymentFeeDtoCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type PaymentFeeDtoCurrencyEnum = typeof PaymentFeeDtoCurrencyEnum[keyof typeof PaymentFeeDtoCurrencyEnum];


/**
 * Check if a given object implements the PaymentFeeDto interface.
 */
export function instanceOfPaymentFeeDto(value: object): value is PaymentFeeDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('fixedFeeAmount' in value) || value['fixedFeeAmount'] === undefined) return false;
    if (!('variableFeePercentage' in value) || value['variableFeePercentage'] === undefined) return false;
    if (!('cardSchemePriceOverrides' in value) || value['cardSchemePriceOverrides'] === undefined) return false;
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function PaymentFeeDtoFromJSON(json: any): PaymentFeeDto {
    return PaymentFeeDtoFromJSONTyped(json, false);
}

export function PaymentFeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentFeeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'currency': json['currency'],
        'fixedFeeAmount': json['fixedFeeAmount'],
        'variableFeePercentage': json['variableFeePercentage'],
        'cardSchemePriceOverrides': ((json['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideFromJSON)),
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function PaymentFeeDtoToJSON(json: any): PaymentFeeDto {
    return PaymentFeeDtoToJSONTyped(json, false);
}

export function PaymentFeeDtoToJSONTyped(value?: PaymentFeeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'currency': value['currency'],
        'fixedFeeAmount': value['fixedFeeAmount'],
        'variableFeePercentage': value['variableFeePercentage'],
        'cardSchemePriceOverrides': ((value['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideToJSON)),
        'locationId': value['locationId'],
        'activeFrom': value['activeFrom'].toISOString(),
        'activeTo': value['activeTo'] == null ? value['activeTo'] : value['activeTo'].toISOString(),
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

